import React from 'react'
import { data } from '../../../hooks/useGitHub'
import { useTranslation } from 'react-i18next'

import './Projects.css'

const Cards = () => {
    const cardData = Object.entries(data[0].repositoryStatus).map((item) => {
        console.log(item[0], item[1])
        return (
            <div className="card">
                <div className="card_title">{item[0]}</div>
                <div className="card_content">{item[1]}</div>
            </div>
        )
    })

    console.log(cardData)
    return <div className="card__container">{cardData}</div>
}
const Projects = () => {
    const { t } = useTranslation()

    return (
        <div className="project">
            {/* Projects panel header */}
            <div className="project__header">
                {/* <div className="project__header_image">
                    <img src="./images/heroku.png" alt="I'm not sure why this broke?"/>
                </div> */}
                <div className="project__header_text">
                    <p>{t('storyboard__project_featured')}</p>
                    <h1>{t('storyboard__project_open_source')}</h1>
                </div>
            </div>
            {/* Project details */}
            <div className="project__content">
                {/* Project overview */}
                <div className="project__content_main">
                    <div className="project__content_main_text">
                        <div className="project__content_main_text_title">
                            {data[0].projectName}:
                        </div>
                        <div className="project__content_main_text_description">
                            {t('storyboard__project_description')}
                        </div>
                    </div>
                    <div className="project__content_main_action">
                        <div className="project__content_main_action_button button">{t('storyboard__project_view_project')}</div>
                        <div className="project__content_main_action_button button">{t('storyboard__project_view_documentation')}</div>
                    </div>
                </div>

                {/* Project tech stack */}
                <div className="project__content_stack">
                    <p className="bold">{t('storyboard__project_tech_stack')}</p>
                    {/* TODO - return the following p tag with api data */}
                    <p>Heroku, Selenium and Shell Scripting</p>
                </div>
                
                {/* Project repository status */}
                <div className="project__content_stats">
                    <div>
                        <p>{t('storyboard__project_repository_status')} </p>
                        <img className="project__content_stats_badge_1" width="8.9%" alt="I'm not sure why this broke?" src="https://travis-ci.org/pyronlaboratory/heroku-integrated-firefox-geckodriver.svg?branch=master" />
                        <img className="project__content_stats_badge_2" width="8%" alt="I'm not sure why this broke?" style={{marginLeft: "25px"}} src="https://camo.githubusercontent.com/78f47a09877ba9d28da1887a93e5c3bc2efb309c1e910eb21135becd2998238a/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4c6963656e73652d4d49542d79656c6c6f772e737667" />
                     </div>
                    <Cards />
                </div>
            </div>
            <div className="project__more">
                <h1>{t('storyboard__project_view_more')}</h1>
                <p>{t('storyboard__project_view_more_text')}</p>
                <div className="project__button button">GitHub</div>
            </div>
        </div>
    )
}

export default Projects
